import React, { Component } from "react";
import { getCMS } from "../services/cmsService";

export class Feature extends Component {
  constructor(props) {
    super(props);

    this.state = {
      features: [],
    };
  }

  async componentDidMount() {
    try {
      const cmsData = await getCMS("Whychooseus");

      this.setState({
        features: cmsData.filter(
          (item) => item.content_type === "13"
        ),
      });

      console.log("WHY CHOOSE US:", cmsData);
    } catch (error) {
      console.log(error);
    }
  }

  render() {
    const { features } = this.state;

    const icons = [
      "fa-chart-line",
      "fa-users",
      "fa-headset",
      "fa-indian-rupee-sign",
      "fa-award",
      "fa-laptop-code",
      "fa-globe",
      "fa-rocket"
    ];

    const delays = [
      "0.1s",
      "0.3s",
      "0.5s",
      "0.7s",
      "0.9s",
      "1.1s",
      "1.3s",
      "1.5s"
    ];

    return (
      <div>
        {/* Feature Start */}
        <div className="container-fluid bg-primary py-5 my-5">
          <div className="container py-5">
            <div className="row g-5">

              {features.map((item, index) => (
                <div
                  key={item.content_id}
                  className="col-md-6 col-lg-3 wow fadeIn"
                  data-wow-delay={
                    delays[index] || "0.1s"
                  }
                >
                  <div className="d-flex align-items-center">

                    <div className="flex-shrink-0 btn-lg-square bg-secondary rounded me-3">
                      <i
                        className={`fa ${
                          icons[index] || "fa-check"
                        } text-white`}
                      ></i>
                    </div>

                    <p className="fs-5 text-white mb-0">
                      {item.content_title}
                    </p>

                  </div>
                </div>
              ))}

            </div>
          </div>
        </div>
        {/* Feature End */}
      </div>
    );
  }
}

export default Feature;